import { IEntityData } from '@samc/taskmanagement-ui';
import { IDealListResponse } from '../Interfaces';
import { PageListCachedDataSource } from './BaseDataSources';

export class ExitDealSource extends PageListCachedDataSource<IDealListResponse> {
  public constructor(buyerId: string | null = null, status: string | null = null, pageSize = Number.MAX_SAFE_INTEGER) {
    super('/datasource/exitdeals', { buyerId, status }, pageSize);
  }
}

export class ExitDealBasicDataSource extends PageListCachedDataSource<IEntityData> {
  public constructor(id: number | null = null, name: string | null = null, type: string | null = null, status: string | null = null) {
    super('/datasource/exitdealsbasic', { id, name, type, status }, Number.MAX_SAFE_INTEGER);
  }
}